/**
 * Composable function for translating strings.
 * @param {String} locale - The locale to use for translation.
 * @param {Object} translations - The translations object.
 * @returns {Object} - An object with the translation function.
 */
export const useTranslate = (locale, translations) => {
    /**
     * Translate a key to a string using the provided translations.
     * @param {String} key - The key to translate.
     * @param {Object} variables - The variables to replace in the translated string.
     * @return {String} - The translated string.
     */
    const translate = (key, variables = {}) => {
        const keys = key.split('.')
        let value = translations[locale || 'bg']

        for (let i = 0; i < keys.length; i++) {
            if (!value) return key

            value = value[keys[i]]
        }

        if (!value) return key

        // Check for plural forms separated by '|'
        if (typeof value === 'string' && value.includes('|')) {
            const count = variables.count || 0
            const forms = value.split('|')

            // Use singular/plural forms based on count
            value = count === 0 ? forms[0] : count === 1 ? forms[1] : forms[2]
        }

        // Replace variables in the translated string
        return value.replace(/{(\w+)}/g, (match, variable) => variables[variable] || match)
    }

    return { translate }
}
